import { render } from "./RemoveCard.vue?vue&type=template&id=6a67dab1&scoped=true"
import script from "./RemoveCard.vue?vue&type=script&lang=js"
export * from "./RemoveCard.vue?vue&type=script&lang=js"

import "./RemoveCard.vue?vue&type=style&index=0&id=6a67dab1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a67dab1"

export default script